import "./CrmLeadManagement.module.css";
import Header from "@/reusable_sections/Header";
import Crmleadmanagement from "./sections/Crmleadmanagement";
import Synergy from "./sections/Synergy";
import Footer from "@/reusable_sections/Footer";
import Pipeline from "./sections/Pipeline";
export default function CrmLeadManagementPage() {
  return <div>
      <Header />
      <Crmleadmanagement />
      <Pipeline id="crm-how-it-works" />
      <Synergy id="crm-why-it-matters" />
      <Footer />
    </div>;
}